export const medicalFactsOpenGraph = '40106a86-d986-4c28-0635-3dbb45012600'
export const defaultPublicOpenGraph = '97830c0b-4b23-4354-007e-bd169be43000'
export const defaultSSPOpenGraph = 'd246eb38-d9dd-4e15-eb91-99b1aeeae000'
export const sspPreview = '17053392-97c0-4fa6-6bf7-63170308e100'
